if (!customElements.get('cart-cross-sell-rules')) {
  customElements.define('cart-cross-sell-rules', class CartCrossSellRules extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
    }

    // Returns a promise resolving to true/false (rule matched or not) so the caller
    // (cart-drawer.js) can decide whether to run the native recommendations widget at
    // all, rather than letting both widgets fetch independently and race to set their
    // own visibility.
    update() {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      const url = `${this.dataset.url}?section_id=${this.dataset.sectionId}`;

      return fetch(url, { signal: this.abortController.signal })
        .then((response) => response.text())
        .then((text) => {
          const wrapper = getDomHtmlFromText(text, '.item-list');
          const matched = wrapper && wrapper.dataset.matched === 'true';
          const items = matched ? Array.from(wrapper.querySelectorAll(this.dataset.itemSelector)) : [];

          if (!items.length) {
            this.classList.add('hidden');
            return false;
          }

          if (wrapper.dataset.randomise === 'true') {
            this.fisherYates(items);
          }

          const displayLimit = parseInt(wrapper.dataset.displayLimit, 10);
          const finalItems = isNaN(displayLimit) ? items : items.slice(0, displayLimit);

          this.renderResults(finalItems);
          this.classList.remove('hidden');
          const nativeRecommendation = document.querySelector('cart-product-recommendations');
          if (nativeRecommendation) {
            nativeRecommendation.classList.add('hidden');
          }
          return true;
        })
        .catch((error) => {
          if (error.name !== 'AbortError') {
            throw error;
          }
          // A newer update() call superseded this one — never resolve, so the
          // superseded call's caller never acts on stale data.
          return new Promise(() => {});
        });
    }

    renderResults(items) {
      const list = this.querySelector('.cart__recommendation-list');
      const sliderComponent = document.createElement('slider-component');
      sliderComponent.classList.add(
        'slider-mobile-gutter',
        'por',
        'slider-component-desktop',
        'slider-component-tablet',
        'slider-component-mobile'
      );
      sliderComponent.dataset.outsidePrevButtonId = `Slider-${this.dataset.sectionId}-prev-button`;
      sliderComponent.dataset.outsideNextButtonId = `Slider-${this.dataset.sectionId}-next-button`;

      const sliderList = document.createElement('ul');
      sliderList.id = `Slider-${this.dataset.sectionId}`;
      sliderList.classList.add('grid', 'slider', 'slider--mobile', 'slider--tablet', 'slider--desktop', 'grid--1-col');

      items.forEach((item, index) => {
        const sliderItem = document.createElement('li');
        sliderItem.id = `Slide-${this.dataset.sectionId}-${index + 1}`;
        sliderItem.classList.add('grid__item', 'slider__slide');
        sliderItem.appendChild(item);
        sliderList.appendChild(sliderItem);
      });

      sliderComponent.appendChild(sliderList);
      list.innerHTML = '';
      list.appendChild(sliderComponent);
    }

    fisherYates(array) {
      let count = array.length;
      let randomnumber;
      let temp;
      while (count) {
        randomnumber = (Math.random() * count--) | 0;
        temp = array[count];
        array[count] = array[randomnumber];
        array[randomnumber] = temp;
      }
    }

    disconnectedCallback() {
      if (this.abortController) {
        this.abortController.abort();
      }
    }
  });
}
